/* Noble Designs custom sections (group b). Self-contained, no dependency on the 5.6 theme.js. */
(() => {
  /**
   * <nd-b-product-recommendations data-url="...">
   * Loads Shopify's product recommendations (section rendering) into itself,
   * the same way Symmetry 8.3's related-products section does. Being a custom
   * element it also re-runs when the section is re-rendered in the theme editor.
   */
  if (!customElements.get('nd-b-product-recommendations')) {
    class NdBProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.loading || this.hasAttribute('loaded')) return;
        const url = this.dataset.url;
        if (!url) return;
        this.loading = true;

        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('nd-b-product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
            }
            this.setAttribute('loaded', '');
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      }
    }
    customElements.define('nd-b-product-recommendations', NdBProductRecommendations);
  }
})();
